module.exports = __webpack_public_path__ + "img/mission.e40d9a01.jpg";